import { render, staticRenderFns } from "./PaymentDelete.vue?vue&type=template&id=6d5416d2"
import script from "./PaymentDelete.vue?vue&type=script&lang=js"
export * from "./PaymentDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports